export enum Languages {
  UND = 'und',
}
